import { FormattedHTMLMessage } from "react-intl";

import { getSafe } from "@jslib/shared/utils/getSafe";

import { type VerificationService, type ProgramTheme } from "../../lib/types/types";

export const RewardsRemainingComponent = ({
  verificationService,
}: {
  verificationService: VerificationService;
}) => {
  const offersRemaining: ProgramTheme["remainingRewardCodes"] = getSafe(
    () => verificationService.programTheme.remainingRewardCodes,
    null,
  );

  if (typeof offersRemaining === "number" && offersRemaining > 0) {
    return (
      <div className="sid-rewards-remaining" role="note">
        <div className="sid-l-space-top-md" />
        <FormattedHTMLMessage
          id="lowRewardPool"
          defaultMessage={verificationService.messages.lowRewardPool}
          values={{ offersRemaining }}
        />
        <div className="sid-l-space-top-sm" />
      </div>
    );
  }

  return null;
};
